import { Fragment, useEffect, useState } from "react";
import Swal from "sweetalert2";
import Laoding from "../../../../components/Loading";
import LoadingButton from "../../../../components/Loading/LoadingButton";
import {
  getByAuthService,
  putRequestByAuth,
} from "../../../../function/helper";
import DownloadContractTerminationButton from "./components/terminate/DownloadContractTerminationButton";
import TerminateText from "./components/terminate/TerminateText";

function Termination() {
  const [isContractTerminated, setIsContractTerminated] = useState(false);
  const [everBeenAgent, setEverBeenAgent] = useState(true);
  const [isLoading, setIsLoading] = useState([true, false]);

  const getData = async () => {
    setIsLoading(cur => {
      cur[0] = true;
      return [...cur];
    });
    const response = await getByAuthService("/agent/v1/is-contract-terminated");
    setIsLoading(cur => {
      cur[0] = false;
      return [...cur];
    });

    if (response && response.status === 200) {
      setIsContractTerminated(response.data.result);
      return;
    }

    setEverBeenAgent(false);
  };

  const terminateContract = async () => {
    setIsLoading(cur => {
      cur[1] = true;
      return [...cur];
    });
    const response = await putRequestByAuth("/agent/v1/terminate-contract");
    setIsLoading(cur => {
      cur[1] = false;
      return [...cur];
    });

    if (response && response.status === 200) {
      Swal.fire({
        icon: "success",
        text: response.data.message,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "green",
      });
      setIsContractTerminated(true);
      return;
    }

    Swal.fire({
      icon: "error",
      text: response.data.message,
      confirmButtonText: "متوجه شدم",
      confirmButtonColor: "gray",
    });
  };

  useEffect(() => {
    getData();
  }, []);

  const confirmButton = () => {
    Swal.fire({
      icon: "warning",
      text: "آیا از فسخ قرارداد خود مطمئنید ؟",
      confirmButtonText: "بله",
      confirmButtonColor: "red",
      cancelButtonText: "خیر",
      customClass: "rtl-all",
      showCancelButton: true,
    }).then(res => {
      if (res.isConfirmed) {
        terminateContract();
      }
    });
  };

  if (isLoading[0]) {
    return <Laoding />;
  }

  if (!everBeenAgent) {
    return <Fragment></Fragment>;
  }

  return (
    <section className="px-1 px-md-4">
      <TerminateText />

      <div className="mt-5">
        {isContractTerminated && <DownloadContractTerminationButton />}

        {!isContractTerminated && (
          <LoadingButton
            center
            className="btn-success-style"
            style={{ width: "200px" }}
            isLoading={isLoading[1]}
            title="تایید فسخ قرارداد و پرینت"
            onClick={confirmButton}
          />
        )}
      </div>
    </section>
  );
}

export default Termination;
